var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_363_12227)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.85 13.3571C1.1048 13.3571 0.5 13.9331 0.5 14.6428C0.5 15.3526 1.1048 15.9286 1.85 15.9286C2.5952 15.9286 3.2 15.3526 3.2 14.6428C3.2 13.9331 2.5952 13.3571 1.85 13.3571ZM5 15.9286H18.5V14.2143H5V15.9286ZM1.85 8.21427C1.1048 8.21427 0.5 8.79027 0.5 9.49998C0.5 10.2097 1.1048 10.7857 1.85 10.7857C2.5952 10.7857 3.2 10.2097 3.2 9.49998C3.2 8.79027 2.5952 8.21427 1.85 8.21427ZM5 10.7857H18.5V9.07141H5V10.7857ZM1.85 3.07141C1.1048 3.07141 0.5 3.64741 0.5 4.35713C0.5 5.06684 1.1048 5.64284 1.85 5.64284C2.5952 5.64284 3.2 5.06684 3.2 4.35713C3.2 3.64741 2.5952 3.07141 1.85 3.07141ZM5 5.64284H18.5V3.92855H5V5.64284Z",
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_363_12227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuButton);
export default __webpack_public_path__ + "static/media/menuButton.57ecc66ede9e4647cdcc42342ca56608.svg";
export { ForwardRef as ReactComponent };